import { Checkbox } from "components/Checkbox";
import { Review } from "services/reviews";

export const columns = (onHeaderClick: (accessor: string) => void) => [
  {
    Header: "Title",
    accessor: "title",
    onHeaderClick: () => onHeaderClick("title"),
  },
  {
    Header: "Slug",
    accessor: "slug",
    onHeaderClick: () => onHeaderClick("slug"),
  },
  {
    Header: "Published",
    headerClassName: "w-10",
    cellClassName: "text-center",
    Cell: ({ row: { original } }: { row: { original: Review } }) => (
      <Checkbox name="published" checked={original.published} disabled />
    ),
    onHeaderClick: () => onHeaderClick("published"),
  },
];
